<template>
    <CustomTopSheetDialog v-model="dialogVisible" :width="900" :title="null" :customclass="'px-4 pt-4'">
        <template #title>
            <h3 class="text-left dialog-title" color="primary">
               Labels - {{ $t('global.menu.backoffice.attribute')}} - {{ $t('global.form.pricing')}}
            </h3>
        </template>

        <template #default>

            <v-row class="shop-info-container">
                <v-col cols="12">
                    <h2 class="text-h6 mb-2">Choose attributes</h2>
                    <v-chip-group v-model="formData.attributes" column multiple>
                        <v-chip label color="primary" :value="attribute" :text="attribute.name"
                            :variant="formData.attributes.some(attr => attr.id === attribute.id) ? 'flat' : 'outlined'" filter
                            :ripple="false" v-for="attribute in attributes" :key="attribute.id">
                            <template v-slot:filter>
                                <v-icon>mdi-check-circle-outline</v-icon>
                            </template>
                        </v-chip>
                    </v-chip-group>
                    <h2 class="text-h6 mb-2">Choose pricing</h2>
                    <v-chip-group v-model="formData.pricing" column mandatory>
                        <v-chip label color="primary" :value="pricing"
                            :variant="formData.pricing === pricing ? 'flat' : 'outlined'" filter
                            v-for="(pricing, index) in ['LOW', 'MEDIUM', 'HIGH', 'VERY_HIGH']" :key="index">
                            <template v-slot:default>
                                <span v-for="i in index + 1" :key="i">€</span>
                                <span class="ml-1">({{ pricing }})</span>
                            </template>
                        </v-chip>
                    </v-chip-group>
                    <h2 class="text-h6 mb-2">Choose Labels</h2>
                    <v-chip-group v-model="formData.labels" column multiple>
                        <template v-for="cat in labelcategories" :key="cat.id">
                            <!-- <v-card :title="cat.name"> -->
                            <v-chip label color="primary" :value="label"
                                :variant="formData.labels.some(lab => lab.id ===label.id) ? 'flat' : 'outlined'" filter
                                v-for="label in cat.labels" :key="label.id">
                                <template v-slot:default>
                                    {{ label.name }}
                                </template>
                            </v-chip>
                            <!-- </v-card> -->
                        </template>
                    </v-chip-group>
                    <!-- {{ formData.labels }} -->
                    <!-- <v-expansion-panels flat density="compact" >
                        <v-expansion-panel title="labels">
                            <template v-slot:text>
                                <v-list>
                                    <v-list-group v-for="cat in labelcategories" :key="cat.id">
                                        <template v-slot:activator="{ props }">
                                            <v-list-item v-bind="props">
                                                {{ cat.name }}
                                            </v-list-item>
                                        </template>

<v-list-item v-for="lab in cat.labels" :key="lab.id">
    {{ lab.name }}
</v-list-item>
</v-list-group>
</v-list>
</template>
</v-expansion-panel>
</v-expansion-panels> -->

                </v-col>

            </v-row>

            <!-- <v-treeview v-model="selectedLocations" :items="items" item-value="id" 
                        selectable open-on-click density="compact" :lines="false" @update:selected="add">
                        <template v-slot:title="{ item }">
                            {{ item.nameTranslations ? item.nameTranslations[`name${selectedLanguage.toUpperCase()}`] :
                                item.properties[`name${selectedLanguage.toUpperCase()}`] }}
                                {{ item.id }}
                        </template>
</v-treeview> -->


        </template>

        <template #actions>
            <v-container class="d-flex align-items-center justify-content-end">
                <v-btn class="px-3 py-1 mr-3" variant="flat" rounded="xl" size="large" prepend-icon="mdi-cancel"
                    color="default" @click="closeSheet">{{ $t('entity.action.cancel') }}</v-btn>
                <v-btn class="px-3 py-1" variant="flat" rounded="xl" size="large" prepend-icon="mdi-content-save"
                    color="primary" @click="save">{{ $t('global.form.save') }}</v-btn>
            </v-container>
        </template>
    </CustomTopSheetDialog>
</template>


<script>
export default {
    name: "ShopTargetDialog",
    data() {
        return {
        }
    },
};
</script>
<script setup>
import { ref, inject, onMounted, computed, watch, getCurrentInstance, defineProps, defineEmits, defineModel } from 'vue';
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';
import LabelCategories from '../LabelCategories.vue';


const dialogVisible = defineModel(); // Handles v-model for visibility
const formData = defineModel("data", { default: () => ({ translations: {} }) }); // Handles v-model for the object
const selectedLanguage = localStorage.getItem('selectedLanguage');
const props = defineProps({
    save: Function, // Define prop as a function
    items: Array
});

const labels = computed(() => props.items.labels)
const attributes = computed(() => props.items.attributes)
const labelcategories = computed(() => {
    return props.items.labelcategories.map(category => ({
        ...category,
        labels: props.items.labels.filter(label => label.labelCategory.id === category.id)
    }));
})




const closeSheet = () => {
    dialogVisible.value = false;
    formData.value = {
        translations: { DE: { value: '' }, EN: { value: '' } },
        attributes: [],
        pricing: '',
        labels: [],
    };
};
onMounted(() => {

});
</script>

<style>
.v-field--appended {
    padding-inline-end: 0px !important;
}

.v-col>.v-label,
.v-col>.v-checkbox .v-label {
    font-weight: 700;
    font-size: 14px;
    opacity: 1;
}

.shop-description-input textarea,
.shop-info-container .v-field__input {
    font-size: 14px !important;
    font-weight: 300 !important;
}

.emoji-picker-container {
    width: 300px;
    /* Adjust width as needed */
    height: 400px;
    /* Adjust height as needed */
    overflow-y: auto;
    /* Add scroll if content overflows */
    padding: 8px;
}

.date-picker .v-field .v-field__append-inner {
    background-color: rgb(var(--v-theme-default)) !important;
}

.time-input .v-field__input {
    padding-right: 0px;
}

.create-news-tabs .v-tab {
    font-weight: 600 !important;
}
</style>

<style scoped>
.v-tab-selected {
    border: 1px solid #ddd !important;
    border-bottom: 0 !important;
}

.v-window-item--active {
    border-top: 0 !important;
    border: 1px solid #ddd !important;
}

.highlighted-country {
    font-weight: 800;
}
</style>
